import { Component, OnChanges, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { Subscription } from 'rxjs';

import { CountryCodes } from '@unpispas/upp-defs';
import { ViewRenderer } from '@unpispas/upp-wdgt';

import { languageService, languageSupport } from '@unpispas/upp-base';
import { viewService } from '@unpispas/upp-base';

import { Client } from '@unpispas/upp-data';

@Component({
    selector: 'upp-client-thumb',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './upp-thumb.html',
    styleUrls: [
        './upp-thumb.scss'
    ],
    providers: [{
        provide: ViewRenderer,
        useFactory: (change: ChangeDetectorRef) => new ViewRenderer(change),
        deps: [ChangeDetectorRef]
    }]
})
export class UppClientThumbComponent extends languageSupport implements OnChanges, OnDestroy {
    @Input() client: Client | null = null;
    @Input() isPayAccount = false;

    @Output() Select = new EventEmitter<Client>();

    private _clientSubscription: Subscription | null = null;

    constructor(
        private lang: languageService,
        private change: ViewRenderer,
        public view: viewService
    ){
        super(lang, change.cdref);
    }

    ngOnChanges(): void {
        if (this._clientSubscription){
            this._clientSubscription.unsubscribe();
            this._clientSubscription = null;
        }

        if (this.client){
            this._clientSubscription = this.client.OnRefresh.subscribe(
            () => {
                this.change.markForCheck();
            });
        }
    }

    ngOnDestroy(): void {
        super.OnDestroy();

        if (this._clientSubscription){
            this._clientSubscription.unsubscribe();
            this._clientSubscription = null;
        }
    }

    OnSelect(): void {
        if (this.client){
            this.Select.emit(this.client);
        }
    }

    get ShowCountry(): boolean {
        return !CountryCodes.Is_ES(this.client?.country) && !!this.Country;
    }

    get Country(): string {
        const _country = String(this.client?.country || '').trim().toUpperCase() || null;
        return (_country && CountryCodes.Code2Name(_country)) || '';
    }
}
